import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme, isSideMenu }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: isSideMenu ? theme.palette.common.white : theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  isSideMenu: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig, isCollapse = false, isSideMenu = false, ...other }) {
  
  return (
    <Box {...other}>
      {navConfig &&
        navConfig?.length &&
        navConfig.map((group, i) => (
          <List key={i} disablePadding sx={{ px: 2 }}>
            <ListSubheaderStyle
              isSideMenu={isSideMenu}
              sx={{
                ...(isCollapse && {
                  opacity: 0,
                }),
              }}
            >
              {group.subheader}
            </ListSubheaderStyle>
            {group?.items?.length > 0 && group.items.map((list, index) => (
              <NavListRoot key={index} list={list} isCollapse={isCollapse} isSideMenu={isSideMenu} />
            ))}
          </List>
        ))}
    </Box>
  );
}
